<template>
  <v-container fluid>
    <span class="title -tongue ml-5">Qual o tipo de solicitação você deseja realizar?</span>
    <v-form
        v-model="valid"
    >
      <v-layout>
        <v-flex >
          <v-radio-group
              :rules="[validationRules.required]"
              column
              :disabled="forceApplicationTypeSelected"
              v-model="applicationTypeSelected"
          >
            <template v-for="applicationType in applicationTypesAvailable">
            <v-radio
                :label="applicationType.name"
                :value="applicationType"
                :disabled="applicationType.acronym === 'LAC'"
                v-if="!forceApplicationTypeSelected || (applicationTypeSelected.id === applicationType.id)"
                :key="applicationType.id"/>
            </template>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <v-layout>
      <v-alert outline color="error" icon="mdi-alert" :value="showNotQualify" class="text-md-center mt-3">
        O seu requerimento não se aplica ao Licenciamento Ambiental por Compromisso, por isso será necessário
        realizar o Licenciamento Ambiental Ordinário
      </v-alert>
      </v-layout>
      <v-layout class="mt-3">
        <v-flex xs6>
          <span class="title -tongue ml-5">Descreva por completo a sua solicitação</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <v-text-field
              :rules="[validationRules.required]"
              v-model="subject"
              counter
              maxlength="500"
          />
        </v-flex>
      </v-layout>

      <v-layout class="mt-3">
        <v-flex xs6>
          <span class="title -tongue ml-5">O empreendimento é de interesse social?</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <v-radio-group v-model="isSocialInterest">
            <v-radio
                label="Sim"
                :value="true"
            ></v-radio>
            <v-radio
                label="Não"
                :value="false"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <v-layout class="mt-3">
        <v-flex xs6>
          <span class="title -tongue ml-5">É uma mudança de titularidade?</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <v-radio-group v-model="isOwnershipChange">
            <v-radio
                label="Sim"
                :value="true"
            ></v-radio>
            <v-radio
                label="Não"
                :value="false"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

      <v-layout class="mt-3">
        <v-flex xs6>
          <span class="title -tongue ml-5">É uma reanálise de processo?</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6>
          <v-radio-group v-model="isProcessReanalysis">
            <v-radio
                label="Sim"
                :value="true"
            ></v-radio>
            <v-radio
                label="Não"
                :value="false"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>

    </v-form>

    <v-divider class="mt-3 mb-3"/>

    <v-layout>
      <v-flex xs6>
        <v-layout justify-space-between>
          <v-btn flat @click="previousStep()">Voltar</v-btn>
          <v-btn color="primary"
                 @click="mountApplicationType"
                 :disabled="!valid">
            Continuar
            <v-icon small right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {includes} from 'lodash'
import validationRules from "@/mixins/validation-rules";

export default {
  name: 'ApplicationTypeStep',

  data() {
    return {
      valid: false,
      validationRules,
      isSocialInterest: false,
      isOwnershipChange: false,
      isProcessReanalysis: false,
      applicationTypeSelected: undefined,
      subject: '',
      showNotQualify: false,
      forceApplicationTypeSelected: false,
    };
  },
  methods: {
    ...mapActions('newApplication', ['previousStep', 'nextStep', 'setApplicationType', 'setValidSteps']),
    mountApplicationType() {

      const payload = {
        subject: this.subject,
        applicationTypeSelected: this.applicationTypeSelected,
        isSocialInterest: this.isSocialInterest,
        isOwnershipChange: this.isOwnershipChange,
        isProcessReanalysis: this.isProcessReanalysis,
        isStudyNeeded: includes([1, 2, 4, 10, 11], this.applicationTypeSelected.id)
      }

      this.setApplicationType(payload);
      this.nextStep();
    },
    autoSelect() {
      if (this.applicationSimplified && this.applicationSimplified.simplified) {
        if (!this.applicationSimplified.qualify || !this.frameworkEntity.qualifySimplifiedTechnicalParameters) {
          this.showNotQualify = true;
          return;
        }

        const applicationType = this.applicationTypesAvailable.find((applicationType) => {
          return applicationType.acronym === 'LAC';
        });

        console.log(
            'applicationType', applicationType
        )

        if (applicationType) {
          this.applicationTypeSelected = applicationType;
          this.forceApplicationTypeSelected = true;
          this.showNotQualify = false;
        }
      } else {
        if (this.applicationTypeSelected && this.applicationTypeSelected.acronym === 'LAC') {
          this.applicationTypeSelected = undefined;
        }
        this.forceApplicationTypeSelected = false;
        this.showNotQualify = false;
      }
    }
  },
  computed: {
    ...mapGetters('newApplication', ['step', 'applicationTypesAvailable', 'applicationSimplified', 'frameworkEntity']),
  },
  watch: {
    isOwnershipChange(newValue) {
      if (newValue) {
        this.isSocialInterest = !newValue;
      }
    },
    isSocialInterest(newValue) {
      if (newValue) {
        this.isOwnershipChange = !newValue;
      }
    },
    valid() {
      this.setValidSteps(this.valid);
    },
    step(newValue) {
      if (newValue && newValue === 5) {
        this.autoSelect()
      }
    }
  },

};
</script>

<style scoped lang="scss">
</style>
